<template>
  <b-row>
    <b-col cols="12">
      <orders-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import OrdersTable from './OrdersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    OrdersTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>